"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../icon/Icon"));
var _tooltip = require("../../tooltip");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ICON_SIZE = 10;
var StyledTooltipError = _styledComponents["default"].div.withConfig({
  displayName: "TooltipError__StyledTooltipError",
  componentId: "sc-9avb8p-0"
})(["", ";"], function (_ref) {
  var theme = _ref.theme;
  var color = theme.palette,
    spacing = theme.spacing,
    genericBorderRadius = theme.extra.genericBorderRadius;
  return (0, _styledComponents.css)(["cursor:pointer;width:", ";height:", ";background-color:", ";text-align:center;border-radius:50%;display:flex;align-items:center;justify-content:center;position:absolute;right:", ";top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);color:white;z-index:2;@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){top:0;bottom:0;margin:auto;}.main-tooltip.styled-tooltip{border-radius:", ";background-color:white;border:1px solid ", ";color:", ";&:after{content:'';border-left-color:", ";}}"], spacing.small, spacing.small, color.validation.error, spacing.tiny, genericBorderRadius, color.validation.error, color.validation.error, color.validation.error);
});
var TooltipError = function TooltipError(_ref2) {
  var error = _ref2.error,
    id = _ref2.id;
  return /*#__PURE__*/_react["default"].createElement(StyledTooltipError, {
    className: "tooltip-container error",
    "data-tip": error,
    "data-place": "left",
    "data-for": "tip-".concat(id)
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-alert",
    size: ICON_SIZE
  }), /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: "tip-".concat(id)
  }));
};
TooltipError.propTypes = {
  id: _propTypes["default"].string.isRequired,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired
};
var _default = exports["default"] = TooltipError;